import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ELocalStorage } from '../enums/ELocalStorage';
import { EUserType } from '../enums/EUserType';
import { IUser } from '../interfaces/IUser';
import { UtilsService } from './utils.service';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    // @ts-ignore
    gUser: IUser;
    token = {
        accessToken: '',
        refreshToken: '',
    };
    userToken = "";

    constructor(private httpClient: HttpClient,
                public router: Router,
                public utilsService: UtilsService,) {
    }

    setUserToLocalStorage(userObj: IUser, p: string) {
        this.gUser = userObj;
        this.gUser.accessToken = this.token.accessToken;
        this.gUser.refreshToken = this.token.refreshToken;
        const encryptedCode = this.utilsService.getEncryptedString(this.gUser, p);
        (<any>window).localStorage.setItem(ELocalStorage.USER, encryptedCode);
    }


    getUserFromLocalStorage(p: string) {
        const value = (<any>window).localStorage.getItem(ELocalStorage.USER);
        if (value) {
            const decryptedObj = this.utilsService.getDecryptedObject(value, p);
            if (decryptedObj) return decryptedObj;
            else (<any>window).localStorage.setItem(ELocalStorage.USER, '');
        }
    }

    getUserId() {
        const tempUser: IUser = <any>this.gUser; // IAmCloudUser also supported
        if (!tempUser) {
            this.logout();
            window.location.reload();
        }

        if (tempUser.usr_type_str === EUserType.ADMIN || tempUser.usr_type_str === EUserType.USER || tempUser.usr_type_str === EUserType.ROOT) {
            return tempUser._id;
        } else throw "Invalid User ID";
    }

    clearLocalStorage() {
        localStorage.clear();
        this.gUser = <any>undefined;
        this.token.accessToken = '';
        this.token.refreshToken = '';
    }

    /**
     * It is common function for BE & STORE both projects.
     */
    async logout() {
        this.clearLocalStorage();
        await this.router.navigate(['/home']);
        setTimeout(() => {
            window.location.reload();
        }, 50)
    }

}
